/* ==========================================================================
   GOLDEA - Kies je verpakking / Automatisch aanvullen
   Plaats dit bestand als: /assets/goldea-subscription-options.js

   Wat dit doet:
   1. Zet bij elke keuze de juiste variant (input name="id") in het
      add-to-cart formulier.
   2. Zet het bijbehorende selling plan (input name="selling_plan").
      Is die leeg, dan is het een eenmalige aankoop.
   3. Rekent de prijs per capsule en de besparing uit, zodat je die
      nergens met de hand hoeft bij te houden.
   4. Werkt de prijs in de bestelknop bij.

   De SEPA/iDEAL-knop komt van de Firmhouse Checkout Button Injector en
   werkt op de cart, niet hier. Dit blok hoeft daar niets voor te doen.
   ========================================================================== */

console.log('[Goldea Firmhouse] goldea-subscription-options.js geladen - v2026-07-23');

(function () {
  'use strict';

  class GoldeaSubscriptionOptions {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.currency = root.dataset.currency || 'EUR';
      this.money = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: this.currency
      });

      this.options = Array.from(root.querySelectorAll('[data-gd-option]'));
      if (!this.options.length) return;

      this.injectSellingPlanInputs();
      this.bindEvents();
      this.sync();
    }

    /* ---------- helpers ---------- */

    get section() {
      return document.querySelector('#shopify-section-' + this.sectionId) || document;
    }

    /* Alle add-to-cart formulieren in deze sectie. Sommige themes hebben
       er meer dan een (bijv. een aparte betaal-in-termijnen form), dus we
       zetten de waarden in allemaal die een variant-input hebben. */
    get forms() {
      return Array.from(this.section.querySelectorAll('form[action*="/cart/add"]'))
        .filter(function (form) {
          return form.querySelector('[name="id"]');
        });
    }

    get selected() {
      return this.options.find(function (o) { return o.checked; }) || this.options[0];
    }

    priceOf(option) {
      return parseInt(option.dataset.price, 10) || 0; // in centen
    }

    /* ---------- koppeling met het formulier ---------- */

    /* Elk add-to-cart formulier krijgt een eigen selling_plan input.
       Shopify leest die uit bij het toevoegen aan de winkelwagen. */
    injectSellingPlanInputs() {
      const template = this.root.querySelector('[data-gd-selling-plan-input]');
      if (!template) return;

      this.forms.forEach(function (form) {
        if (form.querySelector('[data-gd-form-selling-plan]')) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        input.setAttribute('data-gd-form-selling-plan', '');
        form.appendChild(input);
      });
    }

    sync() {
      const option = this.selected;
      if (!option) return;

      const variantId = option.dataset.variantId;
      const sellingPlanId = option.dataset.sellingPlanId || '';

      this.forms.forEach(function (form) {
        const variantInput = form.querySelector('[name="id"]');
        if (variantInput) {
          variantInput.value = variantId;
          /* Sommige themes luisteren op change om hun eigen prijs bij te
             werken. Dit event schaadt niet als het theme er niets mee doet. */
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const planInput = form.querySelector('[data-gd-form-selling-plan]');
        if (planInput) {
          planInput.value = sellingPlanId;
          /* Lege waarde helemaal weglaten, anders stuurt Shopify een
             lege selling_plan mee bij een eenmalige aankoop. */
          planInput.disabled = sellingPlanId === '';
        }
      });

      this.updateCta(option);
    }

    /* Zet de prijs in de bestelknop, als daar een plek voor is.
       Voeg in je theme aan de knop toe: <span data-gd-cta-price></span> */
    updateCta(option) {
      const target = this.section.querySelector('[data-gd-cta-price]');
      if (!target) return;
      target.textContent = ' · ' + this.money.format(this.priceOf(option) / 100);
    }

    bindEvents() {
      const self = this;
      this.options.forEach(function (option) {
        option.addEventListener('change', function () { self.sync(); });
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-gd-sub]').forEach(function (root) {
      if (root.dataset.gdInit) return;
      root.dataset.gdInit = 'true';
      new GoldeaSubscriptionOptions(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Themes die secties opnieuw renderen (quick view, section rendering API) */
  document.addEventListener('shopify:section:load', init);
})();
